import { Campaign, AiCreation } from 'modules/domains/campaign';
import { UpdateCampaignPayload, UpdatedCampaignFields } from 'modules/campaigns/lib/hooks';
import { GraphQLCampaign } from 'modules/campaigns/lib/types';

export const NBA_PREFIX = '[AI Retargeting]';
export const applyNBANaming = (name: string) => name.replace(/^(\[.*\])?\s?/, '[AI Retargeting] ');

/**
 @abstract (Campaign, Number) -> Partial<Campaign>
*/
export const updateCampaignFields = (campaign: Campaign, nbaListId: number) => ({
  name: applyNBANaming(campaign.name),
  listIds: [nbaListId],
  aiCreation: AiCreation.NextBestAction,
});

/**
@abstract ((GraphQLCampaign, Partial<UpdatedCampaignFields>) -> UpdateCampaignPayload) -> ((Campaign, Number) -> UpdateCampaignPayload)
*/
export function updateAICampaignPayload(
  generateCampaignPayload: (
    campaign: GraphQLCampaign,
    updateFields: Partial<UpdatedCampaignFields>,
  ) => UpdateCampaignPayload,
) {
  return (campaign: GraphQLCampaign, nbaListId: number) => {
    return generateCampaignPayload(campaign, updateCampaignFields(campaign, nbaListId));
  };
}
